/* projects/speaker-platform/src/app/pages/texts-to-translate/texts-to-translate.component.scss */
/*# sourceMappingURL=texts-to-translate.component-EGEZGN2U.css.map */
